<template>
  <div>
    <!-- <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      style="top:10px;"
      @click="StoreTypeDialog = true"
    >
      <v-icon color="black">add</v-icon>
    </v-btn> -->
    <userForm
      :dialog="StoreTypeDialog"
      :editedIndex="editedIndex"
      @close="StoreTypeDialog = false"
      :selectedItem="selectedItem"
    />
    <!-- <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field> -->
    <v-data-table
      :headers="headers"
      :loading="types.length == 0&& loading_message == 'black'   ? loading_message : false"
      :items="desserts"
      :pagination.sync="pagination"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ desserts.indexOf(props.item)+1}}</td>
        <td style="padding:6px 0 0 0;">
          <img :src="props.item.store_user_image" width="50px" height="50px" style="border-radius:50px;">
        </td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.tel }}</td>
        <td class="text-xs-center">{{ props.item.email }}</td>
        <td class="text-xs-center">{{ props.item.username }}</td>
         <!--<td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon slot="activator">
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip> 
          <v-tooltip top>
            <v-btn icon slot="activator">
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>-->
      </template>

      <template slot="no-data">
        <div v-if="types.length == 0 && loading_message != 'black'">No data available</div>
        <div v-else>
          <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>
          {{ loading_message == 'black' ? 'Loading data ...' : loading_message}}
        </div>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div> -->
  </div>
</template>

<script>
import userForm from "./UserForm.vue";
import { mapState } from "vuex";
export default {
  data: () => ({
    search: "",
    loading_message: "black",
    selected: [],
    original_data: null,
    store_type_img: [],
    selectedItem: {
      store_type_name_th: null,
      store_type_name_en: null,
      store_type_name_cn: null,
      store_type_service_id: null
    },
    StoreTypeDialog: false,
    dialog: false,
    editedIndex: -1,
    pagination: {
      rowsPerPage: 10,
      page: 1,
      totalItems: 0
    },
    headers: [
      {
        text: "#",
        align: "center",
        value: "index",
        sortable: false
      },
      {
        text: "Image",
        align: "center",
        sortable: false
      },
      {
        text: "Name",
        value: "name",
        align: "center",
        sortable: false
      },
      {
        text: "Tel.",
        align: "center",
        value: "tel",
        sortable: false
      },
      {
        text: "Email",
        align: "center",
        value: "email",
        sortable: false
      },
      {
        text: "Username",
        value: "username",
        align: "center",
        sortable: false
      },
    //   {
    //     text: "Actions",
    //     align: "center",
    //     sortable: false
    //   }
    ],
    desserts: [
          {
            name: 'Frozen Yogurt',
            tel: '+66893219930',
            email: 'ww@gmail.com',
            username: 'frozen'
          },
          {
            name: 'Ginger bread',
            tel: '+66812394320',
            email: 'ww@gmail.com',
            username: 'ginger'
          }]
  }),
  components: {
    userForm
  },
  computed: {
    ...mapState({
      types: state => state.fetchStoreBack.store_type,
      load_edit_index: state => state.fetchStoreBack.load_edit_index
    }),
    pages() {
      if (this.types.length != 0) {
        this.pagination.totalItems = this.types.store_types.length;
      }
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  }
};
</script>

